import { useCallback, useMemo, useState } from 'react';
import type {
	DetailedPricingPackage,
	Periods,
} from '../../../jotai/storefront/detailed-pricing';

export function useModal(initial = false) {
	const [isOpenModal, setIsOpenModal] = useState(initial);
	const open = useCallback(() => setIsOpenModal(true), []);
	const close = useCallback(() => setIsOpenModal(false), []);
	return { isOpenModal, open, close };
}

export function usePackagePrice(
	pkg: DetailedPricingPackage,
	activeTab: Periods,
) {
	return useMemo(() => {
		if (pkg.priceSeasonality === 'seasonal') {
			return activeTab === 'peak' ? pkg.peakPrice : pkg.offPeakPrice;
		}
		return pkg.allYearPrice;
	}, [pkg, activeTab]);
}

export function useFormattedPriceType(type: string) {
	return useMemo(() => {
		if (!type) return '';

		return type.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase());
	}, [type]);
}
